import AuthService from './AuthService';

class AgentRequestService {
    constructor() {
        // CRA only exposes env vars prefixed with REACT_APP_.
        // Prefer REACT_APP_CHATBOT_API_URL but fall back to CHATBOT_API_URL
        // in case it's defined in some environments.
        const rawBaseUrl = process.env.REACT_APP_CHATBOT_API_URL || process.env.CHATBOT_API_URL || '';
        // Normalize to avoid trailing slash issues
        this.rawBaseUrl = rawBaseUrl.replace(/\/+$/, '');
    }

    async getAgentRequests() {
        const token = AuthService.getAccessToken();
        const url = `${this.rawBaseUrl}/private/conversations?agentRequested=true`;
        const response = await fetch(url, {
            method: 'GET',
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });

        if (!response.ok) {
            throw new Error(`HTTP error! Status: ${response.status}`);
        }

        const data = await response.json();
        return data;
    }
}

const agentRequestService = new AgentRequestService();
export { AgentRequestService };
export default agentRequestService;
